/**
 * settings/constants.ts
 * desc: application-wide constants
 * note: `as const` makes the arrays readonly tuples - type consuming props as readonly T[], and check membership with (list as readonly string[]).includes(x)
 */
export default {
    CONNECTION_AUTH: {
        CUSTOM: 'custom',
        OAUTH_2: 'oauth2'
    },
    CONSTANTS_VARIABLES_KEYS: [ 'com_ymeadows_variables', 'com_ymeadows_constants', 'com_ymeadows_environment' ],
    DEFAULT_ORDER_SCHEMA_ID: '6ac1d25f-2667-4f95-bf2e-0429f748c708',
    DEFAULT_PASSWORD_TEXT: '●●●●●●●●●●●●●●●●',
    DOCUMENTATION_URL: 'https://ymeadows.atlassian.net/wiki/spaces/UD/pages/2445639747/Introduction+to+Y+Meadows',
    DOCKER_NAME_VALIDATION: String.raw`[a-z0-9]+(?:[._\-]{1,2}[a-z0-9]+)*`,
    DOCKER_TAG_VALIDATION: String.raw`[\w][\w.\-]{0,127}`,
    EMAIL_VALIDATION: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
    FEATURE_FLAGS: {
        FALLBACK_PATH_PER_VERSION: 'web.fallbackPaths.perVersion.enabled',
    },
    FIELDS: {
        TYPES: [ 'PLAIN_TEXT', 'BOOLEAN', 'HTML', 'KEY_VALUE_PAIRS_V2', 'LIST', 'NUMBER', 'RESOURCE' ],
        SUBTYPES: [ 'PLAIN_TEXT', 'BOOLEAN', 'HTML', 'NUMBER' ],
        RESOURCE_TYPES: [ 'INTENT', 'REVIEW_QUEUE', 'SOURCE', 'SOURCE_TYPE', 'CUSTOM_COLLECTION', 'ORDER_COLUMN', 'LINE_ITEM_COLUMN', 'ORDER_SCHEMA' ]
    },
    GENERATOR_STEP_FACTORIES: {
        CUSTOM: null,
        HTTP_REQUEST: 'REQUEST'
    },
    // "+ Step Factory" popup options → the step type the create page is locked to (null: the user picks one)
    STEP_FACTORY_CREATE_TYPES: {
        CUSTOM: null,
        AI: 'AI'
    },
    HIDDEN_PERMISSIONS: [ 'default-roles-tier0', 'offline_access', 'uma_authorization' ],
    INTENTS_OTHER_ID: '2cae2405-afce-469b-8710-390ec715efce',
    LOCALES: {
        DEFAULT: 'en',
        SUPPORTED: [ 'en', 'fr' ]
    },
    MODELS_SYSTEM_ID: 'ddb8f648-33e7-45ae-9663-b93fa5ed1132',
    PAGINATION: {
        DEFAULT_PAGE_NUMBER: 0,
        DEFAULT_PAGE_SIZE: 12,
        ITEMS_PER_PAGE: [ 12, 25, 50, 100, 250, 500, 1000, 2000 ]
    },
    PASSWORD_MANAGER_IGNORE_AUTOFILL: {
        'data-1p-ignore': true,
        'data-lpignore': true,
        'data-bwignore': true,
        'data-form-type': 'other'
    },
    PROGRESS_METER: {
        HEALTHY: 90,
        CRITICAL: 70
    },
    TABLE: {
        MAX_LABEL_NUMBER: 4
    },
    TRIP_LOGS_ID: {
        QA: '0925bdd0-c4d2-11f0-8fdb-7198f3851ba8',
        PROD: '9f130540-c8f5-11ed-b2e6-e14b6557e1eb'
    },
    SOURCES_UPLOAD_ID: 'e9d84e3e-100b-48b3-ba15-d5f221ad846b',
    SUPPORT_EMAIL: 'info@ymeadows.com',
    SUPPORT_LINK: 'https://ymeadows.atlassian.net/servicedesk/customer/portal/1',
    ZERO_WIDTH_SPACE: '\u200b'
} as const;
